import { render, staticRenderFns } from "./xuqiuSqC.vue?vue&type=template&id=36268864&scoped=true"
import script from "./xuqiuSqC.vue?vue&type=script&lang=js"
export * from "./xuqiuSqC.vue?vue&type=script&lang=js"
import style0 from "./xuqiuSqC.vue?vue&type=style&index=0&id=36268864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36268864",
  null
  
)

export default component.exports